import axios from 'axios'

const callDatabase = async (dealId) => {
  const payload = `dealId=${dealId}`
  try {
    const response = await axios({
      method: 'POST',
      headers: {
        'Content-Type':'application/x-www-form-urlencoded'
      },
      url: 'https://invoicesportal-780758709.development.catalystserverless.com/server/invoices_portal_function/',
      data: payload
    })
    return JSON.parse(response.data.message)
  } catch (error) {
  }
}

export default callDatabase